import {Button, IconButton} from '@dropbox/dig-components/buttons';
import {Drawer} from '@dropbox/dig-components/drawer';
import {Truncate} from '@dropbox/dig-components/truncate';
import {Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {CloseLine} from '@dropbox/dig-icons/assets';
import {Title} from 'components/DSYS/Title';
import {useEffect, useState} from 'react';
import {useLocation} from 'react-router';

import {logWorkstreamsInteraction} from './workstreamsAnalytics';

/**
 * Narrow screens: the rail as a bottom sheet behind a "Current scope ▾" button,
 * so the cards get the full width. Every pick in the rail navigates, so the
 * sheet closes on any location change (re-picking what's open included).
 */
// The sheet's own padding, which its rows bleed back across.
export const SHEET_BLEED = {left: 16, right: 8};

export const MobileNavSheet = ({label, children}: {label: string; children: React.ReactNode}) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.key]);

  return (
    <>
      <Button
        variant="opacity"
        withDropdownIcon
        onClick={() => {
          logWorkstreamsInteraction('mobile_nav_opened');
          setOpen(true);
        }}
        style={{minWidth: 0, maxWidth: '100%'}}
      >
        <Truncate>{label}</Truncate>
      </Button>
      {/* Fits the rail, up to 90% of the screen (then the body scrolls), so a
          strip of the page above says it's temporary. */}
      <Drawer.ModalDrawer
        isOpen={open}
        alignment="bottom"
        height="auto"
        aria-label="Workstreams"
        onRequestClose={() => setOpen(false)}
      >
        <Drawer.Container style={{maxHeight: '90vh'}}>
          <Drawer.Header>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Title size={18}>Workstreams</Title>
              <IconButton variant="transparent" aria-label="Close" onClick={() => setOpen(false)}>
                <UIIcon src={CloseLine} />
              </IconButton>
            </Box>
          </Drawer.Header>
          {/* The rail's own padding, which its rows bleed back across, so their
              fills run the sheet edge to edge. */}
          <Drawer.Body style={{minHeight: 0, padding: 0}}>
            <Box paddingLeft="16" paddingRight="8" paddingBottom="16">
              {children}
            </Box>
          </Drawer.Body>
        </Drawer.Container>
      </Drawer.ModalDrawer>
    </>
  );
};
